// extracted by mini-css-extract-plugin
export default {"stageWrap":"styles_stageWrap__x1j-m","formInput":"styles_formInput__g5CLE"};